import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../pages/Landing/Home.css";
import "../../data/data.json";
import * as MdIcons from "react-icons/md";
import * as FaIcons from "react-icons/fa";
import * as BsIcons from "react-icons/bs";
import * as TbIcons from "react-icons/tb";
import * as HiIcons from "react-icons/hi";
import * as IoIcons from "react-icons/io5";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

const Contact = () => {
  const { reset, handleSubmit, register }: any = useForm();
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [name, setName] = useState("");
  const [newName, setNewName] = useState(name);

  useEffect(() => {
    if (name) setNewName(name?.split(" ")[0]);
  }, [name]);

  const handleSendMsg = () => {
    let inputs: any = document.querySelectorAll("#name, #email, #content");
    console.log(inputs);

    setTimeout(() => {
      inputs.forEach((input: any) => {
        input.value = "";
      });
    }, 1000);

    reset();
    toast.info(`Hey "${newName}", thanks for reaching out!`);
  };

  return (
    <>
      {" "}
      <div className="section_11 py-10" id="section_11">
        <h1 className="text-[30px] font-bold text-center underline mt-10 mb-5">
          Contact me
        </h1>
        <form
          onSubmit={handleSubmit(handleSendMsg)}
          className="block w-[600px] md:border-none md:w-[90%] dark:sm:w-[98%] sm:w-[100%] mx-auto p-5  rounded-[5px] dark:bg-[#092c44] shadow-lg dark:shadow-indigo-500/5"
        >
          <div className="flex items-center md:block">
            <input
              required
              type="text"
              name="name"
              placeholder="Name"
              className="w-[50%] md:w-[100%] my-2 mr-1 md:mr-0 block bg-[#cccccc] dark:bg-[#143b4f] rounded-[5px] h-[40px] indent-2 cursor-text"
              onChange={(e) => setName(e.target.value)}
              id="name"
            />
            <input
              required
              type="email"
              name="email"
              placeholder="Email"
              className="w-[50%]  md:w-[100%] my-2 ml-1 md:ml-0 block bg-[#cccccc] dark:bg-[#143b4f] rounded-[5px] h-[40px] indent-2 cursor-text"
              id="email"
            />
          </div>
          <textarea
            required
            rows={5}
            placeholder="Your message..."
            className="w-[100%] my-2 block bg-[#cccccc] dark:bg-[#143b4f] rounded-[5px]  indent-2 cursor-text"
            id="content"
          ></textarea>
          <input
            type="submit"
            value="Send"
            className="w-[300px] md:w-[100%] my-2 block mx-auto text-white rounded-[5px] h-[40px] bg-[#0093df]  "
          />
        </form>{" "}
      </div>
      <div className="flex flex-col items-center justify-center gap-2 pb-10 text-black mt-[10px]">
        <a href="tel:+250789933604">
          <div className="flex items-center gap-4 p-2 bg-slate-300 rounded-[5px]">
            <BsIcons.BsWhatsapp className="text-green-700 text-[20px]" /> +250
            789 933 604
          </div>
        </a>
        <a href="mailto:rutayisiregerard2002@gmail.com" target="_blank">
          {" "}
          <div className="flex items-center gap-4 p-2 bg-slate-300 rounded-[5px]">
            <BsIcons.BsEnvelope className="text-blue-800 text-[20px]" />{" "}
            rutayisiregerard2002@gmail.com
          </div>
        </a>
      </div>
    </>
  );
};

export default Contact;
